import LessonList from './LessonList';
import LessonCreate from './LessonCreate';
import LessonEdit from './LessonEdit';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const lessonsResource = {
  list: LessonList,
  create: LessonCreate,
  edit: LessonEdit,
  icon: () => <Icon><Box component="img" src='icons/content.svg' /></Icon>,
};

export default lessonsResource;